import { ROLE_COURSE } from "@/constant/permission";
// 课程管理
const courseManage = [
  {
    name: "courseManage",
    path: "courseManage",
    meta: {
      is_meun: true,
      icon: "course",
      title: "课程管理",
      path: "/courseManage",
      roles: ROLE_COURSE
    },
    redirect: "/courseManage/longTermSourse",
    component: () => import(`@/views/courseManage/index.vue`),
    children: [
      {
        name: "longTermSourse",
        path: "longTermSourse",
        meta: {
          is_meun: true,
          title: "长期课",
          roles: ROLE_COURSE,
          path: "/courseManage/longTermSourse"
        },
        redirect: "/courseManage/longTermSourse/longList",
        component: () =>
          import("@/views/courseManage/longTermSourse/index.vue"),
        children: [
          {
            path: "longList",
            component: () =>
              import(
                "@/views/courseManage/longTermSourse/longTermIndex/index.vue"
              )
          },
          {
            path: "longDetail",
            name: "long-detail",
            meta: {
              title: "课程详情",
              title_value: "course_name"
            },
            component: () =>
              import("@/views/courseManage/longTermSourse/details/index.vue")
          }
        ]
      },
      {
        name: "shortTermSourse",
        path: "shortTermSourse",
        meta: {
          is_meun: true,
          title: "短期课",
          roles: ROLE_COURSE,
          path: "/courseManage/shortTermSourse"
        },
        redirect: "/courseManage/shortTermSourse/shortList",
        component: () =>
          import("@/views/courseManage/shortTermSourse/index.vue"),
        children: [
          {
            path: "shortList",
            component: () =>
              import(
                "@/views/courseManage/shortTermSourse/shortTermIndex/index.vue"
              )
          },
          {
            path: "shortDetail",
            name: "short-detail",
            meta: {
              title: "课程详情",
              title_value: "course_name"
            },
            component: () =>
              import("@/views/courseManage/shortTermSourse/details/index.vue")
          }
        ]
      },
      {
        name: "experienceClass",
        path: "experienceClass",
        meta: {
          is_meun: true,
          title: "体验课",
          roles: ROLE_COURSE,
          path: "/courseManage/experienceClass"
        },
        redirect: "/courseManage/experienceClass/experienceIndex",
        component: () =>
          import("@/views/courseManage/experienceClass/index.vue"),
        children: [
          {
            name: "experienceIndex",
            path: "experienceIndex",
            component: () =>
              import(
                /* webpackChunkName: "experienceIndex" */
                "@/views/courseManage/experienceClass/experienceIndex/index.vue"
              )
          },
          {
            path: "experienceDetail",
            name: "experience-detail",
            meta: {
              title: "课程详情",
              title_value: "course_name"
            },
            component: () =>
              import("@/views/courseManage/experienceClass/details/index.vue")
          }
        ]
      }
    ]
  }
];

export default courseManage;
